import { Locale } from 'modules/i18n';

export const addNetworkDialogTranslation = {
  [Locale.en]: {
    addNetworkToWallet: 'Add network to wallet',
  },
};
